import { Component, inject, OnInit } from '@angular/core';
import { IOpenRequest } from '../models/open-request.model';
import { PendingRequestsService } from '../services/pending-requests.service';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { RequestDetailsViewComponent } from '../request-details-view/request-details-view.component';
import { Router } from '@angular/router';
import { LoggedInUserService } from '../../services/common/logged-in-user.service';

@Component({
  selector: 'app-my-open-requests',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatProgressSpinnerModule],
  templateUrl: './my-open-requests.component.html',
  styleUrl: './my-open-requests.component.scss'
})
export class MyOpenRequestsComponent implements OnInit {

  dataSource: IOpenRequest[] = [];
  displayedColumns: string[] = ['number', 'request', 'requestDate', 'requestType', 'status', 'waitingOn'];
  pendingRequestsService: PendingRequestsService = inject(PendingRequestsService);
  loading: boolean = true;

  constructor(
    private modal: MatDialog,
    private router: Router,
    private userService: LoggedInUserService) { }

  ngOnInit(): void {
    this.userService.currentUser$.subscribe(data => {
      if(data == null){
        this.router.navigate(["/unauthorized"]);
      }
    });
    this.pendingRequestsService.getOpenRequests().subscribe({
      next: (data) => {
        this.dataSource = data;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching open requests:', err);
        this.loading = false;
      }
    });
  }

  calculateWaitingOn(element: IOpenRequest): string {
    if (element.requestStatus === "00" || element.requestStatus.charAt(1) === "5") {
      return element.enteredByName;
    } else if (element.requestStatus === "30" || element.requestStatus === "40") {
      return "Imprest Analyst";
    } else if (element.approverName !== null && element.approverName !== "") {
      return element.approverName;
    } else {
      return "";
    }
  }

  openRequest(request: IOpenRequest): void {
    this.modal.open(RequestDetailsViewComponent, {
      data: { requestNumber: request.requestNumber }
    });
  }
}
